import React from 'react';
import { Grid } from '@material-ui/core';
import { Page, Content } from '@backstage/core-components';

import { TestResultsDataView } from './TestResultsDataView';
import { useEntity } from '@backstage/plugin-catalog-react';

export const TestResultsPage = () => {
  const { entity } = useEntity();
  const { kind } = entity;
  const { name } = entity.metadata;
  return (
    <Page themeId="tool">
      {/*
      <Header title="Test Results" subtitle="">
        <HeaderLabel label="Owner" value="Software Infra" />
        <HeaderLabel label="Lifecycle" value="Alpha" />
      </Header>
      */}
      <Content>
        {/*
        <ContentHeader title="Plugin title">
          <SupportButton>A description of your plugin goes here.</SupportButton>
        </ContentHeader>
        */}
        <Grid container spacing={3} direction="column">
          <Grid item>
            <TestResultsDataView component={name} kind={kind} />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
